import { Alert, AlertTitle } from '@mui/material'
import React from 'react'

export const DetalleBeneficiarios = () => {
  return (
    <>
       
        <Alert severity="info">
          <AlertTitle>Info</AlertTitle>
          Aquí podrás encontrar datos de los beneficiarios del empelado.
        </Alert>

    </>
  )
}
